import api from '@/utils/http'

/**
 功能：角色列表
 time: 2025-13-01 17:13:44
 **/
export function getGroupList(data) {
    return api.post('/admin/group/getList', data)
}

/**
 功能：保存角色
 time: 2025-38-02 16:38:38
 **/
export function saveGroup(data) {
    return api.post('/admin/group/eSave', data)
}

/**
 功能：
 time: 2025-42-02 16:42:10
 **/
export function getGroupDetail(group_id) {
    return api.post('/admin/group/getDetail', { group_id: group_id })
}

/**
 功能：
 time: 2025-20-02 17:20:52
 **/
export function deleteGroup(group_id) {
    return api.post('/admin/group/del', {group_id: group_id})
}

/**
 功能：下拉
 time: 2025-49-03 11:49:20
 **/
export function getSelectList() {
    return api.get('/admin/group/getSelectList')
}

